import {useMemo} from 'react';
import {useSelector} from 'react-redux';

export const useIsAuthenticated = () => {
  const {authenticated} = useSelector((state) => state.user);
  return useMemo(() => !!authenticated, [authenticated]);
};
